import Notification from '@/components/Notification';
import styles from './index.module.scss';

interface IUnPublishTip {
    onShowUnPublishTipChange: (params: boolean) => void;
    onSwitchEdit: () => void;
}

export default function UnPublishTip(props: IUnPublishTip) {
    const {onSwitchEdit, onShowUnPublishTipChange} = props;

    function handleNotificationClose() {
        onShowUnPublishTipChange(false);
    }

    function handleClick() {
        handleNotificationClose();
        onSwitchEdit();
    }

    return (
        <div className={styles.notification}>
            <Notification
                type={'info'}
                content={<span>
                    你有未发布的内容，
                    <a
                        onClick={handleClick}
                    >
                        点击查看
                    </a>
                </span>}
                onClose={handleNotificationClose}
            />
        </div>
    );
}
